document.addEventListener("DOMContentLoaded", () => {
  class DrawerElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: "open" });

      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: contents;
          }

          .backdrop {
            display: flex;
            position: fixed;
            inset: 0;
            backdrop-filter: blur(4px);
            z-index: 99999;
            align-items: stretch;
            justify-content: flex-end;

            visibility: hidden;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .backdrop.open {
            visibility: visible;
            opacity: 1;
          }

          .drawer-content {
            border-left: 1px solid var(--Element-black, #222);
            background: white;
            width: 560px;
            height: 100vh;
            /*padding: var(--padding-y ,40px) var(--padding-x, 40px);*/
            transform: translateX(100%);
            transition: transform 0.3s ease;
            box-sizing: border-box;
          }

          .backdrop.open .drawer-content {
            transform: translateX(0);
          }
            
          @media (max-width: 768px) {
            .drawer-content {
              width: 100%;
              height: var(--drawer-height, 85%);
              /*padding: var(--padding-y ,40px) var(--padding-x, 15px);*/
              border: none;
              border-top: 1px solid var(--Element-black, #222);
              max-height: calc(100vh - 60px);
              transform: translateY(100%);
            }    
              
            .notify_drawer.drawer-content {
              height: fit-content
            }

            .backdrop {
              align-items: end;
            }

            .backdrop.open .drawer-content {
              transform: translateY(0);
            }
          }
        </style>

        <slot name="toggle"></slot>
        <div class="backdrop">
          <div class="drawer-content ${this.getAttribute("class")}">
            <slot name="content"></slot>
          </div>
        </div>
      `;
      if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
        this._initDrawer();
      } else {
        document.addEventListener("DOMContentLoaded", () => {
          this._initDrawer();
        });
      }
    }
    _initDrawer() {
      const toggle = this.querySelector("drawer-toggle");
      const content = this.querySelector("drawer-content");
      const backdrop = this.shadowRoot.querySelector(".backdrop");

      if (toggle) toggle.setAttribute("slot", "toggle");
      if (content) content.setAttribute("slot", "content");

      if (!this._movedToBody) {
        document.body.appendChild(this);
        this._movedToBody = true;
      }

      toggle?.addEventListener("click", () => {
        backdrop.classList.add("open");
        lockBodyScroll();
      });

      backdrop?.addEventListener("click", (e) => {
        if (e.target === backdrop) {
          backdrop.classList.remove("open");
          unlockBodyScroll();
        }
      });

      const closeBtn = content?.querySelector(".close");
      closeBtn?.addEventListener("click", () => {
        backdrop.classList.remove("open");
        unlockBodyScroll();
      });

      const id = this.getAttribute("id");
      if (id) {
        window.addEventListener(`open-drawer-${id}`, () => {
          backdrop.classList.add("open");
          lockBodyScroll();
        });

        window.addEventListener(`close-drawer-${id}`, () => {
          backdrop.classList.remove("open");
          unlockBodyScroll();
        });
      }
    }
  }

  customElements.define("drawer-element", DrawerElement);

  class DrawerToggle extends HTMLElement {
    connectedCallback() {
      const drawerId = this.getAttribute("drawer-id");
      if (!drawerId) return;

      this.addEventListener("click", () => {
        const drawer = document.getElementById(drawerId);
        const backdrop = drawer.shadowRoot.querySelector(".backdrop");

        if (backdrop.classList.contains("open")) {
          window.dispatchEvent(new Event(`close-drawer-${drawerId}`));
        } else {
          window.dispatchEvent(new Event(`open-drawer-${drawerId}`));
        }
      });
    }
  }

  customElements.define("drawer-toggle", DrawerToggle);
});
